import React from 'react';
import { useRouterContext, useRouterType, useLink } from '@refinedev/core';
import type { RefineLayoutThemedTitleProps } from '@refinedev/antd';
import { AppIconSide, AppIconSideCollapsed } from '../../../assets/icons';
export const ThemedTitleV2: React.FC<RefineLayoutThemedTitleProps> = ({
  collapsed,
}) => {
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === 'legacy' ? LegacyLink : Link;

  return (
    <ActiveLink to="/" className="flex items-center justify-center w-full">
      <div>{!collapsed ? <AppIconSide /> : <AppIconSideCollapsed />}</div>
    </ActiveLink>
  );
};
